import { PaginationDto } from './pagination.dto';
export abstract class AbstractSearchPaginationResultDto<T> {
  results: T[];
  pagination: PaginationDto;
  totalElements: number;
}
